import styled from 'styled-components';

const Tag = styled.div`
  display: inline-block;
  position: relative;
`;

export { Tag };
